define("SDB.Modal.EntryPoint", [
  "SDB.Modal.Button.View",
  "Facets.Browse.View",
  "Profile.Model",
  "SDB.PLP.Modifications.EntryPoint",
  "SDB.DisplayVehicle.View",
  "CCAW.GoToCheckoutCartDetailedButton.View",
  "CCAW.GoToCheckoutCartSummaryButton.View",
], function (
  SDBModalButtonView,
  FacetsBrowseView,
  ProfileModel,
  SDBPLPModificationsEntryPoint,
  SDBDisplayVehicleView,
  CCAWGoToCheckoutCartDetailedButtonView,
  CCAWGoToCheckoutCartSummaryButtonView
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      /** @type {LayoutComponent} */
      var Layout = container.getComponent("Layout");

      SDBPLPModificationsEntryPoint.mountToApp(container);

      String.prototype.toPascalCase = function () {
        return this.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
        });
      };

      if (Layout) {
        Layout.addChildView("Make.Modal", function () {
          return new SDBModalButtonView({
            container: container,
            isMake: true,
          });
        });

        Layout.addChildView("Vehicle.Modal", function () {
          return new SDBModalButtonView({
            container: container,
          });
        });

        Layout.addChildView("DisplayVehicle.View", function () {
          return new SDBDisplayVehicleView({
            container: container,
          });
        });

        Layout.addChildView(
          "CCAW.GoToCheckoutCartDetailedButton.View",
          function () {
            return new CCAWGoToCheckoutCartDetailedButtonView({
              container: container,
            });
          }
        );

        Layout.addChildView(
          "CCAW.GoToCheckoutCartSummaryButton.View",
          function () {
            return new CCAWGoToCheckoutCartSummaryButtonView({
              container: container,
            });
          }
        );
      }
    },
  };
});
